import React, { createContext, useContext, useState, useCallback } from "react";

const PopupContext = createContext(null);

/**
 * Provides popup open/close state + optional metadata (hidden fields) to the
 * entire component tree.
 *
 * Usage in a child:
 *   const { openPopup } = usePopup();
 *   openPopup({ source: "Hero CTA", plan: "Starter" });
 */
export const PopupProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [meta, setMeta] = useState({});

  const openPopup = useCallback((metadata = {}) => {
    setMeta(metadata);
    setIsOpen(true);
  }, []);

  const closePopup = useCallback(() => {
    setIsOpen(false);
    // keep meta until next open so the last values aren't lost during exit anim
  }, []);

  return (
    <PopupContext.Provider value={{ isOpen, meta, openPopup, closePopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => {
  const ctx = useContext(PopupContext);
  if (!ctx) throw new Error("usePopup must be used inside <PopupProvider>");
  return ctx;
};
